import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 結構化資料
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "聯漢室內設計工作室",
    "telephone": ["+886-921-233-330", "+886-970-747-330"],
    "email": "c11c.tw@yahoo.com.tw",
    "address": [
      {
        "@type": "PostalAddress",
        "streetAddress": "大華路214巷6號",
        "addressLocality": "鳥松區",
        "addressRegion": "高雄市",
        "addressCountry": "TW"
      },
      {
        "@type": "PostalAddress", 
        "streetAddress": "衡陽路128巷40號",
        "addressLocality": "台東市",
        "addressRegion": "台東縣",
        "addressCountry": "TW"
      }
    ],
    "openingHours": "Mo-Sa 08:00-23:30"
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('https://formspree.io/f/mgvkykoy', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          _replyto: formData.email
        })
      });
      if (response.ok) {
        setSubmitted(true);
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        setError('送出失敗，請稍後再試。');
      }
    } catch (err) {
      setError('送出失敗，請檢查網路連線。');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setSubmitted(false);
    setError(null);
  };

  return (
    <section className="contact" id="contact">
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <div className="contact-overlay">
        <div className="contact-container">
          <header className="contact-header">
            <h2 className="section-title">聯絡我們</h2>
          </header>
          <div className="contact-content">
            <aside className="contact-info" itemScope itemType="https://schema.org/LocalBusiness">
              <div className="info-item contact-cards">
                <article className="contact-card" itemScope itemType="https://schema.org/PostalAddress">
                  <h3 className="contact-location">高雄辦公室</h3>
                  <div className="contact-details">
                    <div className="address">
                      <h4>地址：</h4>
                      <address itemProp="streetAddress">高雄市鳥松區大華路214巷6號</address>
                    </div>
                    <div className="phone">
                      <h4>電話：</h4>
                      <a href="tel:0921-233-330" itemProp="telephone">0921-233-330</a>
                    </div>
                    <div className="phone">
                      <h4>電話：</h4>
                      <a href="tel:0970-747-330" itemProp="telephone">0970-747-330</a>
                    </div>
                    <div className="email">
                      <h4>Email：</h4>
                      <a href="mailto:c11c.tw@yahoo.com.tw" itemProp="email">c11c.tw@yahoo.com.tw</a>
                    </div>
                  </div>
                </article>
                <article className="contact-card" itemScope itemType="https://schema.org/PostalAddress">
                  <h3 className="contact-location">台東辦公室</h3>
                  <div className="contact-details">
                    <div className="address">
                      <h4>地址：</h4>
                      <address itemProp="streetAddress">台東縣台東市衡陽路128巷40號</address>
                    </div>
                    <div className="phone">
                      <h4>電話：</h4>
                      <a href="tel:0921-233-330" itemProp="telephone">0921-233-330</a>
                    </div>
                  </div>
                </article>
              </div>
              <div className="info-item business-hours">
                <h3 className="contact-location">營業時間</h3>
                <table className="business-hours-table">
                  <tbody>
                    <tr><td>星期一</td><td itemProp="openingHours" content="Mo 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期二</td><td itemProp="openingHours" content="Tu 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期三</td><td itemProp="openingHours" content="We 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期四</td><td itemProp="openingHours" content="Th 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期五</td><td itemProp="openingHours" content="Fr 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期六</td><td itemProp="openingHours" content="Sa 08:00-23:30">08:00–23:30</td></tr>
                    <tr><td>星期日</td><td>休息</td></tr>
                  </tbody>
                </table>
              </div>
            </aside>
            <div className="contact-form">
              <h3>免費諮詢</h3>
              {submitted ? (
                <div className="form-success-message">
                  <div className="success-icon" role="img" aria-label="成功送出">
                    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="30" cy="30" r="30" fill="#b36b39"/>
                      <path d="M18 32.5L27 41L43 23" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <div className="success-text">
                    <h4>感謝您的來信！</h4>
                    <p>我們已收到您的訊息，將盡快與您聯絡。</p>
                  </div>
                  <button className="reset-btn" onClick={handleReset}>再填一份</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="formspree-form" noValidate>
                  <div className="form-group">
                    <label htmlFor="name">姓名</label>
                    <input 
                      type="text" 
                      id="name" 
                      name="name" 
                      value={formData.name} 
                      onChange={handleChange} 
                      required 
                      disabled={loading}
                      aria-describedby="name-error"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">電子郵件</label>
                    <input 
                      type="email" 
                      id="email" 
                      name="email" 
                      value={formData.email} 
                      onChange={handleChange} 
                      required 
                      disabled={loading}
                      aria-describedby="email-error"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">電話</label>
                    <input 
                      type="tel" 
                      id="phone" 
                      name="phone" 
                      value={formData.phone} 
                      onChange={handleChange} 
                      required 
                      disabled={loading}
                      aria-describedby="phone-error"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="message">留言內容</label>
                    <textarea 
                      id="message" 
                      name="message" 
                      value={formData.message} 
                      onChange={handleChange} 
                      rows="5" 
                      required
                      disabled={loading}
                      aria-describedby="message-error"
                    ></textarea>
                  </div>
                  <input type="hidden" name="_replyto" value={formData.email} />
                  <button type="submit" className="submit-btn" disabled={loading} aria-describedby="form-status">
                    {loading ? '送出中...' : '送出'}
                  </button>
                  {error && <div className="form-error-message" role="alert" id="form-status">{error}</div>}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact; 